/**
 * Reusable LegalNotice component for landing page
 */

import { cn } from "../../lib/utils";
import { LEGAL_NOTICE } from "../../constants/landing";

interface LegalNoticeProps {
  hasConsented: boolean;
  onConsentChange: (consented: boolean) => void;
  theme: {
    colors: {
      text: {
        title: string;
        primary: string;
      };
    };
    components: {
      card: string;
    };
  };
}

export function LegalNotice({ hasConsented, onConsentChange, theme }: LegalNoticeProps) {
  return (
    <div className="mb-2 max-w-2xl mx-auto px-4">
      <div className={cn("p-4 rounded-lg border", theme.components.card)}>
        <h4 className={cn("text-lg font-bold mb-2", theme.colors.text.title)}>
          {LEGAL_NOTICE.title}
        </h4>
        <p id="consent-description" className={cn("text-base mb-3", theme.colors.text.primary)}>
          {LEGAL_NOTICE.content}
        </p>
        <div className="flex items-center">
          <input
            type="checkbox"
            id="consent"
            checked={hasConsented}
            onChange={e => onConsentChange(e.target.checked)}
            aria-describedby="consent-description"
            className="mr-3 h-5 w-5 text-brand-secondary focus:ring-brand-secondary border-border-default rounded"
          />
          <label
            htmlFor="consent"
            className={cn("text-base font-medium", theme.colors.text.primary)}
          >
            {LEGAL_NOTICE.consentLabel}
          </label>
        </div>
      </div>
    </div>
  );
}
